var React = require('react');

function Win11 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Untitled"),React.createElement("style",{"key":1},"tspan { white-space:pre }.shp0 { fill: #0078d4 } "),React.createElement("path",{"className":"shp0","d":"M0 14L0 28L28 28L28 0L0 0L0 14ZM30 14L30 28L58 28L58 0L30 0L30 14ZM0 44L0 58L28 58L28 30L0 30L0 44ZM30 44L30 58L58 58L58 30L30 30L30 44Z","key":2})]);
}

Win11.defaultProps = {"version":"1.2","baseProfile":"tiny-ps","viewBox":"0 0 58 58","width":"41","height":"41"};

module.exports = Win11;

Win11.default = Win11;
